import { render, staticRenderFns } from "./StatesForm.vue?vue&type=template&id=19300d8f"
import script from "./StatesForm.vue?vue&type=script&lang=js"
export * from "./StatesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports